
function loadConfig(configName = 'public-config.json') {
    return fetch(`/${configName}`).then(res => res.json())
}

export default loadConfig
